import React from 'react';
import FieldGroup from '../../components/ui/FieldGroup';
import Spinner from '../../components/ui/Spinner';
import StatusBadge from '../../components/ui/StatusBadge';

const TEXT_FIELDS = [
  ['objective',           'Objetivo'],
  ['activitiesPerformed', 'Actividades realizadas'],
  ['observations',        'Observaciones'],
  ['agreements',          'Acuerdos'],
  ['incidents',           'Incidencias detectadas'],
  ['pendingTasks',        'Pendientes'],
];

export default function ReportTab({
  drawerAssembly,
  drawerReport,
  drawerEvidences,
  isReportLocked,
  reportForm, setReportForm,
  reportSaving,
  onSaveDraft,
  onSubmitReport,
  setDrawerTab,
}) {
  if (drawerAssembly.status === 'canceled') {
    return (
      <p className="info-box">
        La asamblea fue cancelada. No se puede registrar informe.
        {drawerAssembly.cancellationReason ? ` Motivo: ${drawerAssembly.cancellationReason}` : ''}
      </p>
    );
  }

  return (
    <form onSubmit={onSaveDraft} className="report-form">
      {drawerReport?.folio && (
        <div className="folio-bar">
          <span>Folio: <strong>{drawerReport.folio}</strong></span>
          <StatusBadge status={drawerReport.status} />
        </div>
      )}

      <div className="form-row3">
        <FieldGroup label="Fecha real">
          <input type="date" value={reportForm.actualDate} disabled={isReportLocked}
            onChange={e => setReportForm(p => ({ ...p, actualDate: e.target.value }))} required />
        </FieldGroup>
        <FieldGroup label="Hora inicio">
          <input type="time" value={reportForm.actualStartTime} disabled={isReportLocked}
            onChange={e => setReportForm(p => ({ ...p, actualStartTime: e.target.value }))} required />
        </FieldGroup>
        <FieldGroup label="Hora término">
          <input type="time" value={reportForm.actualEndTime} disabled={isReportLocked}
            onChange={e => setReportForm(p => ({ ...p, actualEndTime: e.target.value }))} required />
        </FieldGroup>
      </div>

      <FieldGroup label="Sede (prellenado)" full>
        <input value={drawerAssembly.address} disabled readOnly className="readonly" />
      </FieldGroup>

      <FieldGroup label="Número de asistentes">
        <input type="number" min={0} value={reportForm.attendeesCount} disabled={isReportLocked}
          onChange={e => setReportForm(p => ({ ...p, attendeesCount: e.target.value }))} required />
      </FieldGroup>

      {TEXT_FIELDS.map(([field, label]) => (
        <FieldGroup key={field} label={label} full>
          <textarea rows={3} value={reportForm[field]} disabled={isReportLocked}
            placeholder={label}
            onChange={e => setReportForm(p => ({ ...p, [field]: e.target.value }))} required />
        </FieldGroup>
      ))}

      {!isReportLocked && (
        <div className="report-btns">
          <button type="submit" className="btn-primary btn-report-green" disabled={reportSaving}>
            {reportSaving ? <Spinner /> : 'Guardar borrador'}
          </button>
          {drawerReport && (
            <>
              <button
                type="button"
                className={`btn-submit-final btn-report-green${!drawerEvidences.length ? ' btn-disabled-hint' : ''}`}
                onClick={() => {
                  if (window.confirm('¿Completar asamblea? El informe quedará bloqueado para edición.'))
                    onSubmitReport();
                }}
              >
                Completar
              </button>
              {!drawerEvidences.length && (
                <p className="hint warn-hint">
                  ⚠ Adjunta al menos una evidencia en la pestaña Evidencias para poder enviar.
                </p>
              )}
            </>
          )}
        </div>
      )}

      {isReportLocked && (
        <p className="info-box info-locked">Informe enviado — bloqueado para edición.</p>
      )}
    </form>
  );
}
